import { toggleDebug } from './debug.js';
export const config = {
    stars: {
        count: 500,
        size: 5,
        brightness: 1,
        twinkleSpeed: 0
    },
    sun: {
        enabled: true,
        size: 20,
        intensity: 30,
        color: { r: 255, g: 250, b: 230 },
        posX: -2000,
        posY: 2000,
        posZ: 2000,
       
    },
    floor: {
        color: 0x444444,
        metalness: 0.3,
        roughness: 0.1
    },
    lights: {
        ambient: 0.2,
        ambientColor: 0xf6f7f9,
        directional: 0.7,
        directionalColor: 0xffffff,
        shadowCameraSize: 600
    },
    bloom: {
        strength: 0.7,
        radius: 0.1,
        threshold: 0.1
    },
    svg: {
        emissiveIntensityNormal: 0,
        emissiveIntensityHit: 1.3,
        hitFadeDuration: 1,
        arrayEnabled: true,
        arrayCount: 0,
        arrayRadius: 500,
        arrayType: 'circle',
        raycastHighlight: false
    },
    camera: {
        lookSensitivity: 0.15,
        lookSmoothing: 0.1,
        maxLookAngle: 3.14,
        scrollSpeed: 5,
        scrollDamping: 0.92,
        height: 10,
        minHeight: 0.5,
        maxHeight: 50,
        gimbalSensitivity: 0.0093,
        gimbalMultiplier: 8,
        invertYaw: false,
        invertPitch: false,
        invertScroll: true
    },
    player: {
        jumpMin: 2,
        jumpMax: 10,
        chargeTime: 1.0,
        moveForce: 0.2,
        keyboardMoveSpeed: 0.4,
        gravity: 0.9,
        touchMoveSpeed: 0.3
    },
    projectile: {
        speed: 200,
        size: 0.5,
        color: 0x8fffc7,
        emissive: 0x8fffff,
        emissiveIntensity: 0.7,
        gravityScale: 0.9,
        lifetime: 13000
    },
    magnet: {
        enabled: true,
        initialRadius: 100,  
        maxRadiusBonus: 500,    
        radiusGrowthRate: 50,     
        pullForce: 550,            
        throwForce: 120,         
        coneAngle: 0.6
    },
    physics: {
        gravity: -40,
        cylinderRestitution: 0.1,
        cylinderFriction: 0.2,
        svgRestitution: 0.1,
        svgFriction: 0.2
    },
    mobile: {
        moveSensitivity: 0.6,
        lookSensitivity: 1.2,
        invertYaw: false,
        invertPitch: false,
        autoReturnPitch: true,
        joystickCurve: 'bell',
        joystickPower: 1.8
    },
    images: {
        autoArrange: false,
        arrayType: 'circle',
        arraySpacing: 80
    },
    debug: {
        enabled: false
    },
    rendering: {
    shadowMapSize: 1024,  // Zmniejszone z 2048
    anisotropy: 4,        // Zmniejszone z 16
    antialias: false,     // Wyłączone
    pixelRatio: 2,        // Max 2x
    maxLights: 3          // Limit świateł
}
};

export let guiInstance = null;

export function initGUI() {
    const gui = new lil.GUI();
    gui.title('Scene Controls');
    gui.hide();

    guiInstance = gui;
    
    let guiVisible = false;
    
    window.addEventListener('keydown', (e) => {
        if (e.code === 'KeyU') {
            guiVisible = !guiVisible;
            if (guiVisible) {
                gui.show();
            } else {
                gui.hide();
            }
        }
        if (e.code === 'KeyP') {
            const enabled = toggleDebug();
            config.debug.enabled = enabled;
            console.log(`Debug colliders: ${enabled ? 'ON' : 'OFF'}`);
        }
    });

    const physicsFolder = gui.addFolder('Physics');
    physicsFolder.add(config.physics, 'gravity', 0, 100,).name('Gravity');
    physicsFolder.close();
    
    const lightingFolder = gui.addFolder('Lighting');
    lightingFolder.add(config.lights, 'ambient', 0, 1).name('Ambient Intensity');
    lightingFolder.addColor(config.lights, 'ambientColor').name('Ambient Color');
    lightingFolder.add(config.lights, 'directional', 0, 2).name('Directional Intensity');
    lightingFolder.addColor(config.lights, 'directionalColor').name('Directional Color');
    lightingFolder.add(config.lights, 'shadowCameraSize', 100, 500).name('Shadow Range');
    lightingFolder.close();
    
    const sunFolder = gui.addFolder('Sun');
    sunFolder.add(config.sun, 'enabled').name('Enabled');
    sunFolder.add(config.sun, 'size', 5, 50).name('Size');
    sunFolder.add(config.sun, 'intensity', 0, 50).name('Intensity');
    sunFolder.add(config.sun, 'posX', -5000, 5000).name('Position X');
    sunFolder.add(config.sun, 'posY', 0, 5000).name('Position Y');
    sunFolder.add(config.sun, 'posZ', -5000, 5000).name('Position Z');
    sunFolder.close();
    
    const starsFolder = gui.addFolder('Stars');
    starsFolder.add(config.stars, 'count', 1000, 15000, 500).name('Count');
    starsFolder.add(config.stars, 'size', 0.5, 5).name('Size');
    starsFolder.add(config.stars, 'brightness', 0.1, 2).name('Brightness');
    starsFolder.add(config.stars, 'twinkleSpeed', 0, 1).name('Twinkle Speed');
    starsFolder.close();
    
    const cameraFolder = gui.addFolder('Camera');
    cameraFolder.add(config.camera, 'lookSensitivity', 0.05, 0.3).name('Look Sensitivity');
    cameraFolder.add(config.camera, 'lookSmoothing', 0.02, 0.2).name('Look Smoothing');
    cameraFolder.add(config.camera, 'maxLookAngle', 0.2, 3).name('Max Look Angle');
    cameraFolder.add(config.camera, 'scrollSpeed', 0, 10).name('Scroll Speed');
    cameraFolder.add(config.camera, 'scrollDamping', 0.8, 0.98).name('Scroll Damping');
    cameraFolder.add(config.camera, 'height', 0.5, 50).name('Camera Height');
    cameraFolder.add(config.camera, 'gimbalSensitivity', 0.001, 0.01).name('Gimbal Sensitivity');
    cameraFolder.add(config.camera, 'gimbalMultiplier', 1, 20).name('Gimbal Multiplier');
    cameraFolder.add(config.camera, 'invertYaw').name('Invert Yaw');
    cameraFolder.add(config.camera, 'invertPitch').name('Invert Pitch');
    cameraFolder.add(config.camera, 'invertScroll').name('Invert Scroll');
    cameraFolder.close();
    
    const svgFolder = gui.addFolder('SVG Objects');
    svgFolder.add(config.svg, 'emissiveIntensityNormal', -0.5, 1).name('Normal Emission');
    svgFolder.add(config.svg, 'emissiveIntensityHit', 0, 3).name('Hit Emission');
    svgFolder.add(config.svg, 'hitFadeDuration', 0.2, 3).name('Fade Duration');
    svgFolder.add(config.svg, 'raycastHighlight').name('Raycast Highlight');
    svgFolder.close();
    
    const effectsFolder = gui.addFolder('Post-Processing');
    effectsFolder.add(config.bloom, 'strength', 0, 3).name('Bloom Strength');
    effectsFolder.add(config.bloom, 'radius', 0, 1).name('Bloom Radius');
    effectsFolder.add(config.bloom, 'threshold', 0, 1).name('Bloom Threshold');
    effectsFolder.close();
    
    const playerFolder = gui.addFolder('Player');
    playerFolder.add(config.player, 'jumpMin', 1, 10).name('Jump Min Force');
    playerFolder.add(config.player, 'jumpMax', 0, 20).name('Jump Max Force');
    playerFolder.add(config.player, 'moveForce', 0.1, 1).name('Move Force');
    playerFolder.add(config.player, 'keyboardMoveSpeed', 0.1, 1).name('Keyboard Speed');
    playerFolder.add(config.player, 'touchMoveSpeed', 0.05, 0.8).name('Touch Move Speed');
    playerFolder.close();
    
    const projectileFolder = gui.addFolder('Projectiles');
    projectileFolder.add(config.projectile, 'speed', 20, 200).name('Speed');
    projectileFolder.add(config.projectile, 'size', 0.1, 1).name('Size');
    projectileFolder.addColor(config.projectile, 'color').name('Color');
    projectileFolder.close();
    
    const magnetFolder = gui.addFolder('Magnet Gun');
    magnetFolder.add(config.magnet, 'enabled').name('Enable Magnet');
    magnetFolder.add(config.magnet, 'initialRadius', 10, 100).name('Initial Radius');
    magnetFolder.add(config.magnet, 'maxRadiusBonus', 100, 1000).name('Max Radius Bonus');
    magnetFolder.add(config.magnet, 'radiusGrowthRate', 5, 30).name('Growth Rate');
    magnetFolder.add(config.magnet, 'pullForce', 50, 800).name('Pull Force');
    magnetFolder.add(config.magnet, 'throwForce', 50, 200).name('Throw Force');
    magnetFolder.add(config.magnet, 'coneAngle', 0.3, 1.5).name('Cone Angle');
    magnetFolder.close();
    
    const mobileFolder = gui.addFolder('Mobile Controls');
    mobileFolder.add(config.mobile, 'moveSensitivity', 0.1, 2).name('Move Sensitivity');
    mobileFolder.add(config.mobile, 'lookSensitivity', 0.1, 3).name('Look Sensitivity');
    mobileFolder.add(config.mobile, 'invertYaw').name('Invert Yaw');
    mobileFolder.add(config.mobile, 'invertPitch').name('Invert Pitch');
    mobileFolder.add(config.mobile, 'autoReturnPitch').name('Auto Return Pitch');
    mobileFolder.add(config.mobile, 'joystickCurve', ['linear', 'power', 'bell']).name('Joystick Curve');
    mobileFolder.add(config.mobile, 'joystickPower', 0.5, 3).name('Curve Power');
    mobileFolder.close();
    
    const imagesFolder = gui.addFolder('Image Gallery');
    imagesFolder.add(config.images, 'autoArrange').name('Auto Arrange');
    imagesFolder.add(config.images, 'arrayType', ['circle', 'line', 'grid']).name('Pattern');
    imagesFolder.add(config.images, 'arraySpacing', 0, 100).name('Spacing');
    imagesFolder.close();
    
    const debugFolder = gui.addFolder('Debug');
    debugFolder.add(config.debug, 'enabled').name('Show Colliders (P)').onChange((value) => {
        if (value !== toggleDebug()) {
            toggleDebug();
        }
    });
    debugFolder.close();
}